"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResolveFilterInput = void 0;
// (C) 2021-2022 GoodData Corporation
var react_1 = require("react");
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
/**
 * @internal
 */
exports.useResolveFilterInput = function (filter, connectToPlaceholder, identifier) {
    var _a = sdk_ui_1.usePlaceholder(connectToPlaceholder), resolvedPlaceholder = _a[0], setPlaceholderValue = _a[1];
    var currentFilter = react_1.useMemo(function () {
        var _a;
        return (_a = resolvedPlaceholder !== null && resolvedPlaceholder !== void 0 ? resolvedPlaceholder : filter) !== null && _a !== void 0 ? _a : createFilterFormIdentifier(identifier);
    }, [resolvedPlaceholder, filter, identifier]);
    var setConnectedPlaceholderValue = react_1.useCallback(function (filter) {
        if (connectToPlaceholder) {
            setPlaceholderValue(filter);
        }
    }, [connectToPlaceholder, setPlaceholderValue]);
    return {
        filter: currentFilter,
        setConnectedPlaceholderValue: setConnectedPlaceholderValue,
    };
};
var createFilterFormIdentifier = function (identifier) {
    return sdk_model_1.newNegativeAttributeFilter(sdk_model_1.idRef(identifier), {
        uris: [],
    });
};
//# sourceMappingURL=useResolveFilterInput.js.map